export default {
  app: {
    'not-found_title': 'Error 404',
    'not-found_upper-title': 'Ups! This page doesn’t exist.',
    'not-found_subtitle':
      'Maybe the url is wrong, maybe there is technical error. If you didn’t mistyped anything, please try again and if the error persist you can contact us at',
    'not-found_email': 'support@letsgoi.com',
    'not-results_title': 'Ouch! There are no results for this search.',
    'not-results_subtitle': 'Please, check your spell and try again.',
    'form-errors': 'A field is incorrect! | {totalerrors} fields are incorrects!',
  },
  errors: {
    'error_message_server-error': 'Oops! Autentication failure. Please try again',
    'error_message_network-error':
      'The connection is not responding now. Try again in few minutes and if persists, please contact support',
    message_default:
      "There was a problem. Please, try again and if the problem persists contact us at tech{'@'}letsgoi.com",
    review: 'Please check errors and try again:',
    attention: 'Attention needed:',
  },
  'request-password': {
    title: 'Create a new password',
    subtitle:
      'Please, type below the email associated to your account. If we have it already, we will instantly email you back a link to let you choose a new password for your account.',
    'label__field-email': 'Email',
    'placeholder__field-email': "Ej: dolores{'@'}letsgoi.com",
    'email_error-required': 'Email is required.',
    'email_error-format': 'Email is not valid',
    'btn-submit': 'Send me an email to proceed',
    'processing-message': 'Wait, we are processing your request...',
  },
  'request-password-confirmation': {
    title: 'It’s done. Check your inbox',
    subtitle:
      'We are verifying we have your email. Please, check on your inbox if you received an email to let you create a new password.',
    'btn-back': 'Back',
    footer: 'You will only receive this email just if it is on our records.',
    btn_close: 'You can close this window now.',
  },
  'set_new-password': {
    title: 'Choose your new password',
    'label__field-new-password': 'New Password',
    'label__field-repeat-password': 'Repeat Password',
    'btn-submit': 'Create new password',
    'same-password':
      'Sorry, password doesn’t match on both fields. Review carefully and try again.',
    fallback_message: 'Remember the password must be 8 characters minimum.',
    'new-password_error-required': 'New Password is required.',
    'new-password_error-min-value': 'The Password must be 8 characters minimum.',
    'repeat-password_error-required': 'Repeat Password is required.',
    'new-password_placeholder': '********',
    'repeat-password_placeholder': '********',
    'processing-message': 'Wait, we are processing your request...',
  },
  'set_new-password-confirmation': {
    title: 'New Password Created!',
    'subtitle-1':
      'Your new password was successfully created and is ready for you to log in across LOGI software.',
    'subtitle-2':
      'Please, open the LOGI app or software of your choice and log in to get access by using your new password.',
    'subtitle-3':
      'Please, click the button below to be redirected to the LOGI app or software where you can use the new password.',
    'button-back': 'Back to login',
    btn_login: 'Go to login now',
  },
}
